import axios from "axios";

const serviceAiInterviewer = axios.create({
	// baseURL: "https://ai-interviewer.simplifycv.com/",
	baseURL: "https://ai-interviewer.hire3x.com/",
});
const coderequest = axios.create({
	baseURL:
		// "https://code.simplifycv.com/"  //Development gateway
		// "https://code.simplifymycareer.com/" // Staging gateway
		"https://code.hire3x.com/", // Production Gateway
});
// "https://pythoncode.simplifymycareer.com/"
const serviceLicense = axios.create({
	baseURL: 
	// "https://gateway.simplifycv.com/assessment/lis/", // Developent Gateway
	// "http://api.judge.simplifycv.com/lis/"  // Developent Endpoint

		// "https://ablrb41ade.execute-api.ap-south-1.amazonaws.com/trial/assessment/lis/", // Staging Gateway
		// "https://assesment-api.simplifymycareer.com/lis/"  // Staging Endpoint

		"https://gateway.hire3x.com/assessment/lis/", // Production Gateway
	// "https://assessment-api.hire3x.com/lis/"  // Production Endpoint

	// "http://127.0.0.1:8000/lis/" // Local Server
});
const serviceShare = axios.create({
	baseURL: 
	// "https://gateway.simplifycv.com/assessment/share/", // Developent Gateway
	// "http://api.judge.simplifycv.com/proctoring/" // Developent Endpoint

		// "https://ablrb41ade.execute-api.ap-south-1.amazonaws.com/trial/assessment/share/", // Staging Gateway
		// "https://assesment-api.simplifymycareer.com/proctoring/"  // Staging Endpoint

		"https://gateway.hire3x.com/assessment/share/", // Production Gateway
	// "https://assessment-api.hire3x.com/proctoring/"  // Production Endpoint

	// "http://127.0.0.1:8000/share/"
});
const serviceagent = axios.create({
	baseURL: "http://localhost:3000/",
});

const serviceCandidate = axios.create({
	baseURL: 
	// "https://gateway.simplifycv.com/assessment/can/", // Developent Gateway
	// "http://api.judge.simplifycv.com/can/" // Developent Endpoint

		// "https://ablrb41ade.execute-api.ap-south-1.amazonaws.com/trial/assessment/can/", // Staging Gateway
		// "https://assesment-api.simplifymycareer.com/can/"  // Staging Endpoint

		"https://gateway.hire3x.com/assessment/can/", // Production Gateway
	// "https://assessment-api.hire3x.com/can/"  // Production Endpoint

	// "http://127.0.0.1:8000/can/", // Local Server
});
const serviceBuilder = axios.create({
	baseURL: "https://gateway.hire3x.com/candidate/",
	// baseURL: "http://127.0.0.1:8001/", // Local Server
});
const paymentService = axios.create({
	baseURL: "https://payment.hire3x.com/",
});

const serviceCandidateFakeToken = axios.create({
	baseURL: 
	// "https://gateway.simplifycv.com/assessment/can/", // Developent Gateway
	// "http://api.judge.simplifycv.com/can/" // Developent Endpoint

		// "https://gateway.simplifymycareer.com/assessment/can/", // Staging Gateway
	// "https://assesment-api.simplifymycareer.com/can/"  // Staging Endpoint

		"https://gateway.hire3x.com/assessment/can/", // Production Gateway
	// "https://assessment-api.hire3x.com/can/"  // Production Endpoint

	// "http://127.0.0.1:8000/can/" // Local Server
});
const serviceCandidatev2 = axios.create({
	baseURL: 
	// "https://gateway.simplifycv.com/assessment/can/v2/", // Developent Gateway
	// "http://api.judge.simplifycv.com/can/" // Developent Endpoint

		// "https://ablrb41ade.execute-api.ap-south-1.amazonaws.com/trial/assessment/can/v2/", // Staging Gateway
		// "https://assesment-api.simplifymycareer.com/can/"  // Staging Endpoint

		"https://gateway.hire3x.com/assessment/can/v2/", // Production Gateway
	// "https://assessment-api.hire3x.com/can/"  // Production Endpoint

	// "http://127.0.0.1:8000/can/v2/" // Local Server
});

const serviceMapping = axios.create({
	baseURL: 
	// "https://gateway.simplifycv.com/assessment/tma/", // Developent Gateway
	// "http://api.judge.simplifycv.com/tma/" // Developent Endpoint

		// "https://ablrb41ade.execute-api.ap-south-1.amazonaws.com/trial/assessment/tma/", // Staging Gateway
		// "https://assesment-api.simplifymycareer.com/tma/"  // Staging Endpoint

		"https://gateway.hire3x.com/assessment/tma/", // Production Gateway
	// "https://assessment-api.hire3x.com/tma/"  // Production Endpoint

	// "http://127.0.0.1:8000/tma/" // Local Server
});

const serviceQuestion = axios.create({
	baseURL: 
	// "https://gateway.simplifycv.com/assessment/", // Developent Gateway
	// "http://api.judge.simplifycv.com/"   // Developent Endpoint

		// "https://ablrb41ade.execute-api.ap-south-1.amazonaws.com/trial/assessment/", // Staging Gateway
		// "https://assesment-api.simplifymycareer.com/"  // Staging Endpoint

		"https://gateway.hire3x.com/assessment/", // Production Gateway
	// "https://assessment-api.hire3x.com/"  // Production Endpoint

	// "http://127.0.0.1:8000/" // Local Server
});

const SysToken = axios.create({
	baseURL:
		// "http://keynode.simplifycv.com/" // Development

		// "https://keynode.simplifymycareer.com/", // Staging

		"https://keynode.hire3x.com/", // Production
});

const KeycloakAPIs = axios.create({
	// baseURL: "https://auth.simplifymycareer.com/auth/", // Staging & Development

	baseURL: "https://auth.hire3x.com/auth/", // Production
});

const serviceProctoring = axios.create({
	baseURL: 
	// "https://gateway.simplifycv.com/assessment/proctoring/", // Developent Gateway
	// "http://api.judge.simplifycv.com/proctoring/" // Developent Endpoint

		// "https://ablrb41ade.execute-api.ap-south-1.amazonaws.com/trial/assessment/proctoring/", // Staging Gateway
		// "https://assesment-api.simplifymycareer.com/proctoring/"  // Staging Endpoint

		"https://gateway.hire3x.com/assessment/proctoring/", // Production Gateway
	// "https://assessment-api.hire3x.com/proctoring/"  // Production Endpoint

	// "http://127.0.0.1:8000/proctoring/"
});

const uploadService = axios.create({
	// baseURL: "http://localhost:3000/",
	baseURL: "https://awsmultipart.hire3x.com/",
});

const bulkUploadService = axios.create({
	// baseURL:"https://upload.simplifycv.com"// Development
	// baseURL:"https://upload.simplifycv.com"// Development
	baseURL: "https://upload.hire3x.com", // Development
});

export {
	serviceLicense,
	serviceShare,
	serviceCandidate,
	serviceMapping,
	serviceQuestion,
	SysToken,
	KeycloakAPIs,
	serviceagent,
	serviceProctoring,
	serviceCandidatev2,
	coderequest,
	serviceAiInterviewer,
	serviceCandidateFakeToken,
	uploadService,
	bulkUploadService,
	paymentService,
	serviceBuilder,
};
